function setWindowWH() {
    // get window width and height
    var windowWidth = $('.minimalAbout__list--inner').width();
  //     console.log(windowWidth)
  
     $(".minimalAbout__list--inner").css('height', windowWidth);
  }
  
  // run function on window load and resize
  $(window).on("load resize", function() {
    setWindowWH();
  });
  
  $(function () {
    // 最初のコンテンツ以外は非表示
    // $(".minimalFAQ__accordion--item:not(:nth-child(4)) .minimalFAQ__accordion--content").css("display", "none");
    // 矢印の向きを変えておく
    // $(".minimalFAQ__accordion--item:nth-child(4) .minimalFAQ__accordion--title").addClass("open");
   
    $(".minimalFAQ__accordion--title").click(function () {
      $(".open").not(this).removeClass("open").next().slideUp(300);
      $(this).toggleClass("open").next().slideToggle(300);
    });
  });
  
  // $(document).ready(function() {
  
  //   $('.minimalFAQ__accordion').on('click', '.minimalFAQ__accordion--title', function(e) {
  //     e.preventDefault();
  //     $(this).next('.minimalFAQ__accordion--content').not(':animated').slideToggle();
  //   });
  // });
  
  // Vanilla JS version: https://codepen.io/megganeturner/pen/GRyqvvg
  
  $('a[href^="#"]').on('click',function (e) {
  //   var target = this.hash,
  //       $target = $(target);
  //   console.log(target, $target);
  //   setTimeout(function(){
  //     window.scrollTo({
  //       top: $target.offset().top-126,
  //       behavior: 'smooth'
  //     });
  //   },2000)
  
  //   $('html, body').stop().animate({
  //     'scrollTop': $target.offset().top-126
  //   }, 900, function () {
  //     window.location.hash = target;
  //   });
  });


  /* ログインページのリダイレクト処理 */
  document.addEventListener('DOMContentLoaded', () => {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const param_redirect = params.get("redirect");
    if(param_redirect && (
      param_redirect.indexOf( 'products' ) > -1
      || param_redirect.indexOf( 'collections' ) > -1
      || param_redirect.indexOf( 'blogs' ) > -1
    )){ 
      let $redirect = document.createElement('input'),
        $form = location.pathname === "/account/register" ? document.querySelectorAll('#create_customer, form[action="/account"][method="post"]')[0] : document.querySelectorAll('#customer_login, form[action="/account/login"][method="post"]')[0];
        $redirect.setAttribute('name', 'return_to');
        $redirect.setAttribute('type', 'hidden');
        $redirect.value = param_redirect;
        $form.appendChild($redirect);
    }
  });